"use strict";

var _classCallCheck = require("/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var core_1 = tslib_1.__importDefault(require("@walletconnect/core"));

var utils_1 = require("@walletconnect/utils");

var cryptoLib = tslib_1.__importStar(require("@walletconnect/browser-crypto"));

var WalletConnect = /*#__PURE__*/function (_core_1$default) {
  _inherits(WalletConnect, _core_1$default);

  function WalletConnect(connectorOpts) {
    var _this;

    _classCallCheck(this, WalletConnect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WalletConnect).call(this, {
      cryptoLib: cryptoLib,
      connectorOpts: connectorOpts
    }));
    utils_1.logDeprecationWarning();
    return _this;
  }

  return WalletConnect;
}(core_1.default);

exports.default = WalletConnect;